import find from 'lodash/find';
import head from 'lodash/head';
import reduce from 'lodash/reduce';

export class ServiceAreaCountyService {
    constructor($resource, $cookies, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;

        this.serviceAreaResourceUrl = this.apiService.getResourceUrl('cms/program/service-area/:service_area_id');
        this.filterServiceAreaResourceUrl = this.apiService.getResourceUrl('cms/program/service-area/filter');
        this.serviceAreaLinkContentResourceUrl = this.apiService.getResourceUrl('cms/transportation-alternative/:service_area_id');
        this.serviceAreaLinkContentResource = this.$resource(this.serviceAreaLinkContentResourceUrl);

        this.serviceAreaResource = this.$resource(this.serviceAreaResourceUrl, null, {
            delete: {
				method: 'DELETE',
				params: {
					service_area_id: '@service_area_id'
				}
			}
        });
        this.filterServiceAreaResource = this.$resource(this.filterServiceAreaResourceUrl);
    }

    getServiceAreaList([serviceAreaDetails]) {
        return this._getServiceAreaDetailsObject(serviceAreaDetails.values);
    }

    getFilteredServiceAreaListByServiceAreaType({ limit, pageId }, serviceAreaType) {
        const promise = this.filterServiceAreaResource.get({
            limit,
            page_id: pageId,
            service_area_type: serviceAreaType
        }).$promise;

        return promise
            .then(({ data }) => this._getFormattedServiceAreasObject(data))
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    addServiceAreaCounty(details) {
        const promise = this.serviceAreaResource.save(this._setServiceAreaDetailsObject(details)).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    getServiceAreaTypeList() {
        return [{
            id: 1,
            name: 'county',
            count: 0,
            isSelected: true
        }, {
            id: 2,
            name: 'town',
            count: 0,
            isSelected: false
        }, {
            id: 3,
            name: 'village',
            count: 0,
            isSelected: false
        }, {
            id: 4,
            name: 'township',
            count: 0,
            isSelected: false
        }];
    }

    deleteServiceArea(serviceAreaId) {
        const promise = this.serviceAreaResource.delete({service_area_id: serviceAreaId}).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    getServiceAreaTypeOptions(serviceAreas) {
        const serviceAreaTypeList = this.getServiceAreaTypeList();
        return this._getOrderWiseServiceAreaOptionsList(serviceAreaTypeList, serviceAreas);
    }

    getContentLinkedWithServiceArea(serviceAreaId) {
        const promise = this.serviceAreaLinkContentResource.get({service_area_id: serviceAreaId}).$promise;

        return promise
            .then(({data}) => ({
                transportationProviders: this._getServiceAreaContentObject(data.transportation_providers)
            }))
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    _getServiceAreaContentObject(values) {
        return values.map(({
            content_id: contentId,
            details,
            service_area: serviceArea
        }) => ({
            contentId,
            name: details.name,
            image: details.image,
            serviceArea: this._getServiceAreaObject(serviceArea)
        }));
    }

    _getServiceAreaObject(values) {
        return values.map(({
            service_area_id: serviceAreaId,
            service_area_name: name
        }) => ({
            serviceAreaId,
            name
        }));
    }

    _setServiceAreaDetailsObject({ latlng, name, stateCode: state_code, type }) {
        return {
            name,
            latlng,
            state_code,
            type
        };
    }

    _getOrderWiseServiceAreaOptionsList(serviceAreaTypeList, serviceAreas) {
        return reduce(serviceAreaTypeList, (filteredServiceArea, { name }) => {
            let serviceAreaDetails = find(serviceAreas, { type: name });
            if (serviceAreaDetails) {
                let { type: title, name: value } = serviceAreaDetails;
                filteredServiceArea.push({ id: title, title, value });
            }
            return filteredServiceArea;
        }, []);
    }

    _getServiceAreaDetailsObject(data) {
        return data.map(({ service_area_type: serviceAreaType, count, values }) => ({
            serviceAreaType,
            count,
            values: this._getFormattedServiceAreasObject(values),
            isSelected: false
        }));
    }

    _getFormattedServiceAreasObject(data) {
        return data.map(({ service_area_id: serviceAreaId, name, provider_linked: providersLinked, state_code: stateCode, bicycle_and_pedestrian_linked:bicycleAndPedestrianLinked, mobility_manager_linked:mobilityManagerLinked, ridesharing_linked:ridesharingLinked, progress_report_linked:progressReportLinked }) => ({
            serviceAreaId,
            name: `${name}, ${stateCode}`,
            providersLinked,
            ridesharingLinked,
            mobilityManagerLinked,
            bicycleAndPedestrianLinked,
            progressReportLinked
        }));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/service-area/service-area.service.js